import { createPopper } from '@popperjs/core';
/* returns popper Instance with options depending on given 'mode' */
export function initPopper(content, mode, toggle) {
  let popperInstance;
  if (mode === 'flash') {
    function generateGetBoundingClientRect() {
      return () => ({
        width: 0,
        position: 'fixed',
        height: 0,
        top: window.innerHeight,
        right: 0,
        bottom: 0,
        left: window.innerWidth / 2
      });
    }
    const virtualElement = {
      getBoundingClientRect: generateGetBoundingClientRect(),
    };
    popperInstance = createPopper(virtualElement, content, {
      placement: 'top',
      strategy: 'fixed'
    });
  }
  else if (toggle && mode === 'slot') { // case slotted togler / menu
    const toggleWidth = toggle.offsetWidth;
    popperInstance = createPopper(toggle, content, {
      placement: 'bottom-start',
      strategy: 'fixed',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, -toggleWidth],
          },
        }
      ],
    });
  }
  else if (toggle && mode === 'external') { // case external trigger / dropdown
    popperInstance = createPopper(toggle, content, {
      placement: 'bottom-start',
      strategy: 'fixed',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 4],
          },
        }
      ]
    });
  }
  else if (mode === 'position-left' || mode === 'position-right') {
    function generateGetBoundingClientRect() {
      return () => ({
        width: 0,
        position: 'fixed',
        height: 0,
        top: 0,
        right: 0,
        bottom: window.innerHeight,
        left: mode === 'position-right' ? window.innerWidth : 0
      });
    }
    const virtualElement = {
      getBoundingClientRect: generateGetBoundingClientRect(),
    };
    popperInstance = createPopper(virtualElement, content, {
      placement: 'top',
      strategy: 'fixed'
    });
  }
  else if (content) { // case centered
    function generateGetBoundingClientRect(x = 0, y = 0) {
      return () => ({
        width: 0,
        position: 'fixed',
        height: 0,
        top: window.innerHeight / 2,
        right: x,
        bottom: y,
        left: window.innerWidth / 2,
      });
    }
    const virtualElement = {
      getBoundingClientRect: generateGetBoundingClientRect(),
    };
    popperInstance = createPopper(virtualElement, content, {
      placement: 'bottom',
      strategy: 'fixed',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: ({ placement, popper }) => {
              if (placement === 'bottom') {
                return [0, -(popper.height / 2)];
              }
              else {
                return [];
              }
            }
          }
        }
      ]
    });
  }
  return popperInstance;
}
